<template>
    <div class="list-header">
        <div class="left-icon">
            <img src="../assets/common/list-icon.png" />
        </div>
        <div class="title-text">{{ title }}</div>
        <div class="right-icon">
            <img src="../assets/common/list-right-icon.png"/>
        </div>
        <transition name="fade-slide">
            <div class="right-component" v-if="$slots.right">
                <slot name="right"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'ListHeader',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="less">
.list-header {
    height: 40px;
    padding: 0 10px;
    background-color: #012F57;
    display: flex;
    flex-direction: row;
    position: relative; /* 添加相对定位，使绝对定位的子元素相对于此容器定位 */

    .left-icon {
        width: 16px;
        height: 16px;
        align-self: center;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .title-text {
        flex: 1;
        font-size: 18px;
        line-height: 18px;
        padding: 10px 10px;
        background: linear-gradient(180deg, #FFFFFF 16%, #CFF1FF 82%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        font-weight: bold;
        align-self: center;
    }

    .right-component {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        /* 确保组件不会超出父容器范围 */
        max-width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .right-icon {
        width: 21px;
        height: 3px;
        align-self: flex-end;
        margin-bottom: 8px;
        display: flex;

        img{
            width: 100%;
            height: 100%;
        }
    }
}

/* 动画效果 */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateX(20px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}
</style>